"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Action() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const reassurances = ["Expert-led guidance", "Wildlife advocacy", "Community impact"];
  return <section data-section-id="317" id="take-action-now" className="dark bg-[#0F3D2E] text-[#F7FBFF] relative overflow-hidden rounded-lg px-6 py-24 md:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-32 -right-32 h-[28rem] w-[28rem] rounded-lg opacity-40 blur-3xl" style={{
      background: "#0000FF"
    }} />

      {}
      <svg aria-hidden="true" className="pointer-events-none absolute top-10 left-8 h-16 w-16 opacity-70 md:top-14 md:left-14 md:h-20 md:w-20" viewBox="0 0 80 80" fill="none" stroke="#228B22" strokeWidth="2" strokeLinecap="round">
        <circle cx="40" cy="40" r="14" />
        <line x1="40" y1="8" x2="40" y2="18" />
        <line x1="40" y1="62" x2="40" y2="72" />
        <line x1="8" y1="40" x2="18" y2="40" />
        <line x1="62" y1="40" x2="72" y2="40" />
        <line x1="17" y1="17" x2="24" y2="24" />
        <line x1="56" y1="56" x2="63" y2="63" />
        <line x1="63" y1="17" x2="56" y2="24" />
        <line x1="24" y1="56" x2="17" y2="63" />
      </svg>

      <div ref={ref} className={`relative z-10 mx-auto flex max-w-[720px] flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
        {}
        <div className="mb-8 inline-block -rotate-[4deg] rounded-lg px-4 py-1.5 text-xs font-semibold tracking-[0.18em] shadow-md" style={{
        backgroundColor: "#228B22",
        color: "#EAF4EA"
      }}>
          PROTECT OUR WILDLIFE
        </div>

        {}
        <h2 className="font-default font-semibold text-5xl leading-[1.05] tracking-tight text-[#F7FBFF] sm:text-6xl md:text-7xl">
          Ready to help{" "}
          <em className="font-default italic" style={{
          color: "#0000FF"
        }}>
            the refuges?
          </em>
        </h2>

        {}
        <svg aria-hidden="true" className="mt-6 h-5 w-40" viewBox="0 0 160 20" fill="none" stroke="#0000FF" strokeWidth="2.5" strokeLinecap="round">
          <path d="M4 12 Q 20 2, 36 12 T 68 12 T 100 12 T 132 12 T 156 12" />
        </svg>

        {}
        <p className="mt-8 max-w-xl text-lg leading-relaxed text-[#F7FBFF]/70 md:text-xl">
          Join Friends of the Refuges in our mission to inform the public on how to protect our wildlife and sea bird refuges, ensuring a thriving future for Protection Island and Dungeness.
        </p>

        {}
        <div className="mt-10 flex w-full flex-col items-stretch justify-center gap-4 sm:flex-row sm:items-center">
          <Button asChild size="lg" className="h-16 rounded-lg px-8 text-base font-semibold shadow-lg transition-transform hover:-translate-y-0.5 hover:shadow-xl" style={{
          backgroundColor: "#0000FF",
          color: "#F7FBFF"
        }}>
            <Link to="/GetInvolvedPage" className="flex items-center justify-center">
              Get Involved
              <ArrowRight className="ml-1 size-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="h-16 rounded-lg border-2 border-[#F7FBFF]/40 bg-transparent px-8 text-base font-semibold text-[#F7FBFF] hover:bg-[#F7FBFF]/10 hover:text-[#F7FBFF]">
            <Link to="/OurMissionPage" className="flex items-center justify-center">
              Learn Our Mission
            </Link>
          </Button>
        </div>

        {}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-2 gap-y-2 text-sm text-[#F7FBFF]/65 md:text-base">
          {reassurances.map((item, i) => <div data-index={i} key={item} className="flex items-center gap-2">
              <span className="flex items-center gap-1.5">
                <span style={{
              color: "#0000FF"
            }}></span>
                {item}
              </span>
              {i < reassurances.length - 1 && <span aria-hidden="true" className="mx-1 inline-block h-1 w-1 rounded-lg bg-[#F7FBFF]/30" />}
            </div>)}
        </div>
      </div>
    </section>;
}